import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { CHAT_STATUS } from '@whatsper/texterchat-common/constants';
import { BoxValueTypes } from '../components/Box';
import { withStore } from '../../../store/rootStore';
import Row from '../components/Row';
import { formatAsPercent } from '../../BulkReportsDrawer/helpers';
import { ReactComponent as CheckSquare } from '../../../assets/icons/dashboard/CheckSquare.svg';
import { ReactComponent as Dashboard } from '../../../assets/icons/dashboard/Dashboard.svg';
import { ReactComponent as UserAdd } from '../../../assets/icons/dashboard/UserAdd.svg';
import s from '../DashboardDrawer.module.scss';
const Overview = ({ store: { dashboard, departmentsStore } }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const { [CHAT_STATUS.PENDING]: pending, [CHAT_STATUS.ASSIGNED]: assigned, } = dashboard.data;
    const totalPending = ((_a = pending === null || pending === void 0 ? void 0 : pending.total[0]) === null || _a === void 0 ? void 0 : _a.chatsCount) || 0;
    const totalTaken = ((_b = assigned === null || assigned === void 0 ? void 0 : assigned.total[0]) === null || _b === void 0 ? void 0 : _b.chatsCount) || 0;
    const slaSumOfDepartments = ((_c = dashboard.departmentSlaData) === null || _c === void 0 ? void 0 : _c.reduce((acc, dept) => {
        const total = dept.success + dept.failure;
        return acc + (total ? dept.success / total : 0);
    }, 0)) || 0;
    const slaPercent = departmentsStore.departments.length
        ? slaSumOfDepartments / departmentsStore.departments.length
        : 0;
    // Bot-resolved chats are tracked outside this dashboard, so overview resolved is agent-resolved total
    const totalResolved = ((_d = dashboard.resolvedData) === null || _d === void 0 ? void 0 : _d.departments.reduce((acc, { agent_resolved }) => {
        acc += agent_resolved;
        return acc;
    }, 0)) || 0;
    return (React.createElement("div", { className: s['overview__container'] },
        React.createElement(Row, { boxData: [
                {
                    title: t('pending'),
                    data: {
                        type: BoxValueTypes.SIMPLE,
                        value: totalPending || 0,
                    },
                },
                {
                    title: t('taken'),
                    icon: React.createElement(UserAdd, null),
                    data: { value: totalTaken, type: BoxValueTypes.SIMPLE },
                },
                {
                    title: t('resolved'),
                    icon: React.createElement(CheckSquare, null),
                    data: {
                        type: BoxValueTypes.SIMPLE,
                        value: totalResolved,
                    },
                },
                {
                    title: t('SLA'),
                    icon: React.createElement(Dashboard, null),
                    data: {
                        type: BoxValueTypes.SIMPLE,
                        value: formatAsPercent(slaPercent * 100),
                    },
                },
            ], inverted: true })));
};
export default withStore(observer(Overview));
